"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _subset = _interopRequireDefault(require("../set/subset.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Chronological = /*#__PURE__*/function () {
  function Chronological() {
    _classCallCheck(this, Chronological);
  }

  _createClass(Chronological, null, [{
    key: "partition",
    value:
    /**
     * Partition items into subsets
     *
     * @static
     *
     * @param {Item[]} items
     * @param {number} count
     * @return {Subset[]}
     */
    function partition(items, count) {
      var subsets = _toConsumableArray(Array(count)).map(function (_) {
        return new _subset["default"]();
      });

      if (count > 0) {
        items.forEach(function (item, index) {
          return subsets[index % count].append(item);
        });
      }

      return subsets;
    }
    /**
     * Append item to one of the subsets
     *
     * @static
     *
     * @param {Subset[]} subsets
     * @param {Item} item
     * @return {number}
     */

  }, {
    key: "append",
    value: function append(subsets, item) {
      if (!Array.isArray(subsets) || !subsets.length) {
        throw new Error('Cannot append without subsets');
      }

      var count = subsets.reduce(function (a, c) {
        return a + c.count();
      }, 0);
      var index = count % subsets.length;
      subsets[index].append(item);
      return index;
    }
  }]);

  return Chronological;
}();

exports["default"] = Chronological;